import { useQuery } from '@tanstack/react-query';
import { ApiCompanyAndContactsRepository } from 'services/company-and-contacts/ApiCompanyAndContactsRepository';
import { QueryKeys } from 'utils/queryKeys';
import type { CompositeEntityId, CrmCompany } from 'services/company-and-contacts/mappers';

const EMPTY_CRM_COMPANIES: CrmCompany[] = [];

export const useCrmCompaniesByContactId = ({ contactId, enabled = true }: { contactId?: CompositeEntityId; enabled?: boolean } = {}) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: QueryKeys.getCrmCompaniesByContactId(contactId),
    queryFn: () => ApiCompanyAndContactsRepository.getCrmCompaniesByContactId(contactId as CompositeEntityId),
    enabled: enabled && !!contactId,
  });
  return { crmCompanies: data ?? EMPTY_CRM_COMPANIES, isLoading, isError };
};
